import { Calculation, PaymentFrequency } from '@servicetitan/financing-api-client';
import { Payment } from './Payment';

interface StandardInstallmentProps {
    plan: Calculation;
    currentFrequency?: PaymentFrequency;
}

export const StandardInstallment = ({ plan, currentFrequency }: StandardInstallmentProps) => {
    return <Payment plan={plan} eyebrowText="Min. Payment" currentFrequency={currentFrequency} />;
};
